export * from './plugin-hmr.js'
export * from './plugin-dev.js'
export const name = '@tnega/plugin-host'

export * from './routes.js'
